import * as yup from 'yup';

import { TimestampType } from '@britishcouncil/common-core';

export const lrwSessionFormSchema = yup.object({
  sessionDate: yup.mixed<TimestampType>().required('Required'),
  sessionStartTime: yup.string().required('Required'),
  sessionEndTime: yup.string().required('Required'),
  venueId: yup.number().required('Venue is a required field'),
  testTakerAdmissionTimeMinutes: yup.number().min(0).max(99).nullable().default(null),
  onComputerEnabled: yup.boolean().default(false),
  onPaperEnabled: yup.boolean().default(false),
});

export type LrwSessionFormValues = yup.InferType<typeof lrwSessionFormSchema>;
